export default "__VITE_ASSET__f3a9d75b__"